import React from "react";
import CarouselThumbLoop from "./CarouselThumbLoop";
import Link from "next/link";

export const PlaylistCarouselLayout = ({ articleToShow }) => {
  return <CarouselThumbLoop articleThumbLoop={articleToShow} />;
};

export default PlaylistCarouselLayout;
